import { render, staticRenderFns } from "./ProfileForm.vue?vue&type=template&id=50ea9362&"
import script from "./ProfileForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports